import cx from 'classnames';
import { Location } from 'history';
import { hasMergedForumAndGroups } from 'mk2/apps/forum/utils';
import GroupsMenu from 'mk2/components/GroupsMenu';
import Panel from 'mk2/components/Panel';
import { MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import {
    AppState,
    getPageHeaderState,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import { connect } from 'react-redux';
import styles from './LeftMenu.mscss';

interface OwnProps {
    className?: string;
    location: Location;
    mergedForumAndGroups?: boolean;
    section?: string;
}

interface StateProps {
    feedMenu: MenuItem[];
    mobile: boolean;
    requestUser: UserEntity;
    requestUserPermissions: string[];
}

type Props = OwnProps & StateProps;

export class LeftMenu extends React.PureComponent<Props> {

    public static defaultProps: Partial<OwnProps> = {
        section: 'forum_and_groups',
    };

    public render() {
        const {
            className, feedMenu, location, mergedForumAndGroups, mobile, requestUser, requestUserPermissions, section,
        } = this.props;

        if (mobile) {
            return null;
        }

        return (
            <Panel className={cx(styles.LeftMenu, className)}>
                <GroupsMenu
                    fluxibleCompatibility={false}
                    feedMenu={feedMenu}
                    currentUrl={`${location.pathname}${location.search}`}
                    mergedForumAndGroups={mergedForumAndGroups || hasMergedForumAndGroups(requestUser)}
                    mobile={false}
                    requestUserPermissions={requestUserPermissions}
                    section={section}
                />
            </Panel>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        feedMenu: getPageHeaderState(state).feedMenu,
        mobile: getRequestDeviceMobile(state),
        requestUser: getRequestUser(state),
        requestUserPermissions: getRequestPermissions(state),
    };
}

export default connect(mapStateToProps)(LeftMenu);
